import React from "react";
import { Bars } from "react-loader-spinner";
import UserCard from "../components/common/UserCard";
import { useGetAllUserQuery } from "../redux/slices/api/userApi";
import Container from "../components/common/Container";
import MetaTags from "../components/common/MetaTags";

const Users = () => {
  const { isLoading, data: allUsersData } = useGetAllUserQuery();

  return (
    <div className="w-full flex flex-col pt-32 items-center">
      <MetaTags
        title="Users"
        description={`NFT- Fundraising By FunDeSci An innovative approach for decentralized crowdfunding of scientific projects`}
        link="/users"
      />
      <section className="w-full flex flex-col justify-center items-center py-14 bg-secondary">
        <h1 className="text-4xl abel-font font-bold text-white tracking-wider">
          Users
        </h1>
      </section>
      <Container>
        {isLoading ? (
          <div className="w-full min-h-[480px] flex justify-center items-center">
            <Bars
              height="50"
              width="50"
              color="#8538ff"
              ariaLabel="bars-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
          </div>
        ) : (
          <div className="w-full grid grid-cols-1 mlg:grid-cols-2 2xl:grid-cols-3 gap-5 my-10">
            {allUsersData?.map((user) => (
              <UserCard key={user?._id} userData={user} />
            ))}
          </div>
        )}{" "}
      </Container>
    </div>
  );
};

export default Users;
